import Loadable from 'react-loadable';

import { LoadingPage } from 'src/components/react-loadable';

const PipelinesRepoSshKeysPageLoadable = Loadable<any, never>({
  loading: LoadingPage,
  loader: () => import('./ssh-keys'),
});

// eslint-disable-next-line import/no-default-export
export default PipelinesRepoSshKeysPageLoadable;
